"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/MapEventType
 */

/**
 * @enum {string}
 */
var _default = {
  /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */
  POSTRENDER: 'postrender',

  /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */
  MOVESTART: 'movestart',

  /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */
  MOVEEND: 'moveend',

  /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/render/Event~RenderEvent#loadstart
   * @api
   */
  LOADSTART: 'loadstart',

  /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/render/Event~RenderEvent#loadend
   * @api
   */
  LOADEND: 'loadend'
};
/***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2I7Ozs7O0VBS0FBLFVBQVUsRUFBRSxZQU5DOztFQVFiOzs7OztFQUtBQyxTQUFTLEVBQUUsV0FiRTs7RUFlYjs7Ozs7RUFLQUMsT0FBTyxFQUFFLFNBcEJJOztFQXNCYjs7Ozs7RUFLQUMsU0FBUyxFQUFFLFdBM0JFOztFQTZCYjs7Ozs7RUFLQUMsT0FBTyxFQUFFO0FBbENJLEM7QUFxQ2YiLCJuYW1lcyI6WyJQT1NUUkVOREVSIiwiTU9WRVNUQVJUIiwiTU9WRUVORCIsIkxPQURTVEFSVCIsIkxPQURFTkQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL01hcEV2ZW50VHlwZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==